<script setup lang="ts">
// Note that this isn't a component that exists in grammar-web.
export interface GrammarTextProps {
  text: string;
  size?: 'small' | 'medium' | 'large';
}

withDefaults(defineProps<GrammarTextProps>(), {
  size: 'medium',
});

const sizeClasses = {
  small: 'text-sm',
  medium: 'text-base',
  large: 'text-lg',
};
</script>

<template>
  <p class="text-light-label-primary dark:text-dark-label-primary" :class="sizeClasses[size]">
    {{ text }}
  </p>
</template>
